import * as React from "react";
const SvgFiRrDrinkAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.341 5.125A2.98 2.98 0 0 0 19 4h-4.327l.127-1.11a1 1 0 0 1 .99-.89H20a1 1 0 1 0 0-2h-4.21a3 3 0 0 0-2.981 2.669L12.661 4H5a3.02 3.02 0 0 0-2.944 3.556l1.512 12.066A5.01 5.01 0 0 0 8.529 24h6.941a5.01 5.01 0 0 0 4.962-4.379l1.5-11.968a2.98 2.98 0 0 0-.591-2.528M19 6a1 1 0 0 1 .781.375 1.07 1.07 0 0 1 .179.937L19.622 10h-5.616l.445-4zm-14.779.374A1 1 0 0 1 5 6h7.437l-.445 4H4.374l-.35-2.784a1 1 0 0 1 .197-.842m14.226 13A3.005 3.005 0 0 1 15.47 22H8.529a3 3 0 0 1-2.976-2.626L4.626 12h14.745zm-5.009-4.264-.444 4a1 1 0 1 1-1.988-.22l.444-4a1.014 1.014 0 0 1 1.105-.884 1 1 0 0 1 .883 1.104"
    />
  </svg>
);
export default SvgFiRrDrinkAlt;
